import template from './appHeader.html';

export default {
  restrict: 'E',
  template
};
